export default __webpack_public_path__ + "static/media/Archive.2603ab66.svg";